<template>
  <div class="load-more-control">
    <BaseButton
      :ariaLabel="ariaLabel"
      centered
      :color="color"
      :loading="isLoading"
      :variant="variant"
      @click="handleClick"
    >
      {{ label }}
    </BaseButton>
  </div>
</template>

<script setup lang="ts">
import type { BaseButtonProps } from '../atoms/BaseButton.vue';
import BaseButton from '../atoms/BaseButton.vue';

export interface LoadMoreControlProps {
  isLoading?: boolean;
  label?: string;
  ariaLabel?: string;
  variant?: BaseButtonProps['variant'];
  color?: BaseButtonProps['color'];
}

interface Emits {
  'load-more': [];
}

const props = withDefaults(defineProps<LoadMoreControlProps>(), {
  isLoading: false,
  label: 'Load more',
  ariaLabel: undefined,
  variant: 'outline',
  color: 'neutral',
});

const emit = defineEmits<Emits>();

const handleClick = () => {
  if (!props.isLoading) {
    emit('load-more');
  }
};
</script>

<style>
.load-more-control {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: var(--gap-md);
}
</style>
